import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledChartContainer = styled(Box, {
  border: '$borderWidths$1 solid $seafoam500',
  borderRadius: '$radii$4',
  padding: '$4 $2',
  width: '100%',
});
